module.exports = __webpack_public_path__ + "img/File-png.5e17a72f.svg";